import { type MailboxInfo } from "owa-client-types";
import type { TokenParam } from "./tokenResponse";
import type { MailboxTypeHint } from "owa-account-source-list-types";
import type { HeadersWithoutIterator } from "owa-service/lib/RequestOptions";
import type { ScenarioType } from "./Scenario";
import { type IdentityInfo } from "owa-auth-types";

export type ResourceTokenRequestParams = {
    userId: string;
    typeHint: MailboxTypeHint;
    resource: string;
    correlationId: string;
    wwwAuthenticateHeaderValue?: string;
    scope?: string;
    naa?: NestedAppAuthTokenRequest;
    additionalParameters?: TokenParam[];
    userInfo: MailboxInfo | IdentityInfo;
};

export type CredentialParam = {
    name: string;
    value: string;
};

export type NestedAppAuthTokenRequest = {
    platformBrokerId?: string;
    clientId: string;
    redirectUrl: string;
    authority?: string;
    scope: string;
    correlationId?: string;
    claims?: string;
    state?: string;
    reqCnf?: string;
    keyId?: string;
    authenticationScheme?: string;
    shrClaims?: string;
    shrNonce?: string;
    resourceRequestMethod?: string;
    resourceRequestUri?: string;
    extendedExpiryToken?: boolean;
    extraParameters?: CredentialParam[];
};

export enum CredentialSecretType {
    Token = "Token",
    Password = "Password",
    Secret = "Secret",
    Other = "Other"
}

export type CredentialRequestParams = {
    userId: string;
    identityProviderHint: MailboxTypeHint;
    resource: string;
    correlationId: string;
    uniqueIdentifier?: string;
    credentialSecretType: CredentialSecretType;
    wwwAuthenticateHeaderValue?: string;
    scope?: string;
    additionalParameters?: CredentialParam[];
    userInfo: MailboxInfo | IdentityInfo;
};

export interface TokenRequestParams {
    resource?: string;
    scope?: string;
    requestId: string;
    scenarioType: ScenarioType;
    mailboxInfo?: MailboxInfo;
    apiName?: string;
    showFullTokenResponse?: boolean;
    wwwAuthenticateHeader?: string;
    headers?: HeadersWithoutIterator;
    targetTenantId?: string;
    preferIdpToken?: boolean;
    sendClientCapabilityClaim?: boolean;
    claims?: string;
    suppressInteractiveFallback?: boolean;
}

export interface EnterpriseTokenRequestParams extends TokenRequestParams {
    resource: string;
    setUserTokenPayload?: boolean;
}

export interface ConsumerTokenRequestParams extends TokenRequestParams {
    scope: string;
    client_id?: string;
    redirect_uri?: string;
    authorization_uri?: string;
}

export interface ShadowMailboxTokenRequestParams extends TokenRequestParams {
    redirect_uri?: string;
}
